import axios from "axios";

export default {
    getIconFileName(icon) {
        switch (icon) {
            case 0:
                return 'sun.gif'
            case 1:
            case 2:
            case 3:
            default:
                return 'cloud_sun.gif'
            case 45:
            case 48:
                return 'mist.gif'
            case 51:
            case 53:
            case 55:
            case 56:
            case 57:
            case 61:
            case 63:
            case 65:
            case 66:
            case 67:
            case 80:
            case 81:
            case 82:
                return 'cloud_rain.gif'
            case 71:
            case 73:
            case 75:
            case 77:
            case 85:
            case 86:
                return 'cloud_snow.gif'
            case 95:
            case 96:
            case 99:
                return 'cloud_thunder_rain.gif'
        }
    },

    getByInstallation(installation) {
        return new Promise(async (resolve) => {
            const result = await axios.get('https://api.open-meteo.com/v1/forecast', {
                params: {
                    latitude: installation.latitude,
                    longitude: installation.longitude,
                    daily: 'weathercode,temperature_2m_max,temperature_2m_min',
                    timezone: "auto",
                    current_weather: 'true'
                }
            })
            resolve(result.data)
        });
    },
};
